module.exports = __webpack_public_path__ + "static/media/Children.d63e1121.svg";